import { Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';

import { trackButtonClick } from '../../analytics/mixpanel';
import { CardImg, ChatImg, DocChatLogo, DocChatPageImg, FilterImg } from '../../assets';
import DocComparePageImg from '../../assets/DocComparePageImg.svg';
import { useContractSubscriptions } from '../../utils/hooks/useContractSubscriptions';

const ProductSubscription = () => {
  const navigate = useNavigate();
  const contractSubscriptions = useContractSubscriptions();

  return (
    <div className='product-section'>
      <h1 className='heading'>Choose Subscription</h1>
      <p className='info'>You can access your subscriptions by clicking on the buttons below:</p>
      <div className='flex-row card-container'>
        <Card className={`product-card ${!contractSubscriptions.docCompare ? 'disabled' : ''}`}>
          <h1 className='product-heading'>Mike</h1>
          <h1 className='product-heading'>DocCompare</h1>
          <p className='product-discription'>
            Effortlessly simple, fast & precise document comparison tool for Lawyers.
          </p>
          <Button
            type='primary'
            className='select-button'
            onClick={() => {
              trackButtonClick({ type: 'Product Selected DocCompare' });
              navigate('/doccompare');
            }}
          >
            Select
          </Button>
          <div className='image-overlay-container'>
            <div className='background-image'>
              <img src={DocComparePageImg} alt='LoginLeftImage' className='left-layout-img' />
            </div>
            <div className='overlay-image overlay1'>
              <FilterImg />
            </div>
            <div className='overlay-image overlay2'>
              <CardImg />
            </div>
          </div>
        </Card>
        <Card className={`product-card ${!contractSubscriptions.docChat ? 'disabled' : ''}`}>
          <h1 className='product-heading'>Mike</h1>
          <h1 className='product-heading'>DocChat</h1>
          <p className='product-discription'>
            We are working on building this awesome document chat bot, with which you find document
            info asap. Details coming soon.
          </p>
          <Button
            type='primary'
            className='select-button'
            onClick={() => {
              trackButtonClick({ type: 'Product Selected DocChat' });
              navigate('/docchat');
            }}
          >
            Select
          </Button>
          <div className='image-overlay-container'>
            <div className='background-image'>
              <DocChatPageImg />
            </div>
            <div className='overlay-image overlay3'>
              <DocChatLogo />
            </div>
            <div className='overlay-image overlay4'>
              <ChatImg />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ProductSubscription;
